/**
* Do not edit directly
* Generated on Fri, 15 Aug 2025 16:47:00 GMT
*/

module.exports = {
  "brand-background-image": "radial-gradient(78.02% 20% at 50% 0%, hsl(287deg 20% 10%) 0%, hsl(197deg 6% 5%) 100%)",
  "brand-secondary-50": "#001e40",
  "brand-secondary-100": "#053d7d",
  "brand-secondary-200": "#0e5fb6",
  "brand-secondary-300": "#2f88e1",
  "brand-secondary-400": "#3c94e7",
  "brand-secondary-500": "#4fa2eb",
  "brand-secondary-600": "#76b8ee",
  "brand-secondary-700": "#9ecef1",
  "brand-secondary-800": "#c0dff3",
  "brand-secondary-900": "#dfedf5",
  "brand-success-50": "#024011",
  "brand-success-100": "#097d28",
  "brand-success-200": "#13b63e",
  "brand-success-300": "#1ecd4d",
  "brand-success-400": "#34e162",
  "brand-success-500": "#53eb79",
  "brand-success-600": "#7aee97",
  "brand-success-700": "#a0f1b4",
  "brand-success-800": "#c1f3cd",
  "brand-success-900": "#dff5e4",
  "brand-warning-50": "#401502",
  "brand-warning-100": "#7d2e09",
  "brand-warning-200": "#b64913",
  "brand-warning-300": "#da6429",
  "brand-warning-400": "#e77b41",
  "brand-warning-500": "#eb8b53",
  "brand-warning-600": "#eea67a",
  "brand-warning-700": "#f1c0a0",
  "brand-warning-800": "#f3d7c1",
  "brand-warning-900": "#f5e9df",
  "brand-danger-50": "#400203",
  "brand-danger-100": "#7b080c",
  "brand-danger-200": "#b21316",
  "brand-danger-300": "#c91e21",
  "brand-danger-400": "#d5282b",
  "brand-danger-500": "#e65156",
  "brand-danger-600": "#e9777b",
  "brand-danger-700": "#ec9da0",
  "brand-danger-800": "#eebdbf",
  "brand-danger-900": "#fae6e7",
  "brand-primary-accent-50": "#110040",
  "brand-primary-accent-100": "#25057d",
  "brand-primary-accent-200": "#3b0eb6",
  "brand-primary-accent-300": "#5423da",
  "brand-primary-accent-400": "#5e2fe1",
  "brand-primary-accent-500": "#6a3ce7",
  "brand-primary-accent-600": "#9676ee",
  "brand-primary-accent-700": "#b49ef1",
  "brand-primary-accent-800": "#cec0f3",
  "brand-primary-accent-900": "#e5dff5",
  "brand-secondary-accent-50": "#351e0c",
  "brand-secondary-accent-100": "#603412",
  "brand-secondary-accent-200": "#99541b",
  "brand-secondary-accent-300": "#df8d29",
  "brand-secondary-accent-400": "#eda130",
  "brand-secondary-accent-500": "#f5b937",
  "brand-secondary-accent-600": "#fbd65b",
  "brand-secondary-accent-700": "#f9df7f",
  "brand-secondary-accent-800": "#f6e7ab",
  "brand-secondary-accent-900": "#faf6e3",
  "brand-neutral-warm-50": "#141314",
  "brand-neutral-warm-100": "#2b2729",
  "brand-neutral-warm-200": "#423c3f",
  "brand-neutral-warm-300": "#585155",
  "brand-neutral-warm-400": "#6f666b",
  "brand-neutral-warm-500": "#9d9298",
  "brand-neutral-warm-600": "#b3a8ae",
  "brand-neutral-warm-700": "#cac0c6",
  "brand-neutral-warm-800": "#e1d8dd",
  "brand-neutral-warm-900": "#f7f0f4",
  "brand-neutral-cool-50": "#121314",
  "brand-neutral-cool-100": "#1b1d20",
  "brand-neutral-cool-200": "#393d42",
  "brand-neutral-cool-300": "#4d5258",
  "brand-neutral-cool-400": "#61676f",
  "brand-neutral-cool-500": "#8a929d",
  "brand-neutral-cool-600": "#9fa8b3",
  "brand-neutral-cool-700": "#b6bfca",
  "brand-neutral-cool-800": "#cdd6e1",
  "brand-neutral-cool-900": "#e4edf7",
  "brand-surface-elevation-50": "#0c0c0d",
  "brand-surface-elevation-100": "#141415",
  "brand-surface-elevation-200": "#181a1b",
  "brand-surface-elevation-300": "#1b1c1d",
  "brand-surface-elevation-400": "#1f2123",
  "brand-surface-elevation-500": "#222326",
  "brand-surface-elevation-600": "#242628",
  "brand-surface-elevation-700": "#292b2e",
  "brand-surface-elevation-800": "#2c2d30",
  "brand-surface-elevation-900": "#303236",
  "brand-surface-layer-50": "#141415",
  "brand-surface-layer-100": "#18181b",
  "brand-surface-layer-200": "#1b1b1d",
  "brand-surface-layer-300": "#1f1f23",
  "brand-surface-layer-400": "#222226",
  "brand-surface-layer-500": "#242428",
  "brand-surface-layer-600": "#2a2a2d",
  "brand-surface-layer-700": "#2e2e33",
  "brand-surface-layer-800": "#35353b",
  "brand-surface-layer-900": "#3d3d43",
  "brand-primary-border-50": "rgba(251, 249, 250, 0.05)",
  "brand-primary-border-100": "rgba(251, 249, 250, 0.1)",
  "brand-primary-border-200": "rgba(251, 249, 250, 0.2)",
  "brand-primary-border-300": "rgba(251, 249, 250, 0.3)",
  "brand-primary-border-400": "rgba(251, 249, 250, 0.4)",
  "brand-primary-border-500": "rgba(251, 249, 250, 0.6)",
  "brand-primary-border-600": "rgba(251, 249, 250, 0.5)",
  "brand-primary-border-700": "rgba(251, 249, 250, 0.7)",
  "brand-primary-border-800": "rgba(251, 249, 250, 0.8)",
  "brand-primary-border-900": "rgba(251, 249, 250, 0.9)",
  "brand-market-temp-cold": "#2f88e1",
  "brand-market-temp-cool": "#76b8ee",
  "brand-market-temp-neutral": "#dff5e4",
  "brand-market-temp-warm": "#f9df7f",
  "brand-market-temp-hot": "#eb8b53",
  "brand-market-temp-font-cold": "#9ecef1",
  "brand-market-temp-font-cool": "#dfedf5",
  "brand-market-temp-font-neutral": "#ffffff",
  "brand-market-temp-font-warm": "#faf6e3",
  "brand-market-temp-font-hot": "#f5e9df",
  "brand-primary-50": "#111718",
  "brand-primary-100": "#1f2e33",
  "brand-primary-200": "#2d4c53",
  "brand-primary-300": "#31636d",
  "brand-primary-400": "#397f89",
  "brand-primary-500": "#3ca6b4",
  "brand-primary-600": "#50cedc",
  "brand-primary-700": "#72e1ee",
  "brand-primary-800": "#8ef0fb",
  "brand-primary-900": "#d2f9fe",
  "brand-hb-black": "#000000",
  "brand-hb-white": "#ffffff",
  "brand-hb-homebot": "#f85099",
  "brand-hb-homebot-fill": "#322c3a",
  "brand-hb-core-logic": "#e53e24",
  "brand-hb-realty-trac": "#ab24e5",
  "brand-hb-zillow": "#0076e4",
  "brand-hb-shadow-neutral-10": "rgba(4,4,6,.1)",
  "brand-hb-shadow-neutral-15": "rgba(4,4,6,.15)",
  "brand-hb-shadow-neutral-20": "rgba(4,4,6,.2)",
  "brand-hb-shadow-neutral-30": "rgba(4,4,6,.3)",
  "brand-hb-shadow-neutral-05": "rgba(4,4,6,.05)",
  "brand-hb-shadow-neutral-06": "rgba(4,4,6,.06)",
  "brand-hb-shadow-neutral-07": "rgba(4,4,6,.07)",
  "brand-hb-shadow-neutral-08": "rgba(4,4,6,.08)"
}